import "./../../index.css";
import { Fragment } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  createBooking,
  updateBooking,
  deleteBooking,
  setBookingAverage,
} from "../../store/Booking/booking.action";
import NumberFormat from "react-number-format";
import { numberFormat } from "../../utils/utils";

export default function Bookings() {
  const bookings = useSelector((state) => state.booking, shallowEqual);
  const dispatch = useDispatch();

  const handleAddFields = () => {
    dispatch(createBooking());
  };

  const handleRemoveFields = (bookingId) => {
    dispatch(deleteBooking(bookingId));
  };

  const handleInputChange = (index, fieldName, event) => {
    let tempBookings = [...bookings.bookings];
    if (fieldName === "rate") {
      tempBookings[index].bookingRate = event.value;
    } else if (fieldName === "pureWeight") {
      tempBookings[index].pureWeight = event.value;
    } else if (fieldName === "amount") {
      tempBookings[index].bookingAmount = event.value;
    }

    // if (tempBookings[index].bookingRate !== "" && fieldName === "pureWeight") {
    //   calcBookingAmount(index);
    // }

    if (tempBookings[index].bookingRate !== "" && fieldName === "amount") {
      calcPureWeight(index);
    }

    calcTotal();
    dispatch(updateBooking(tempBookings));
  };

  const calcPureWeight = (index) => {
    bookings.bookings[index].pureWeight = (
      bookings.bookings[index].bookingAmount /
      bookings.bookings[index].bookingRate
    ).toString();
  };

  // const calcBookingAmount = (index) => {
  //   bookings.bookings[index].bookingAmount = (
  //     bookings.bookings[index].pureWeight * bookings.bookings[index].bookingRate
  //   ).toString();
  // };

  const calcTotal = () => {
    let amount = 0,
      pureWeight = 0,
      rate = 0;
    bookings.bookings.forEach((ele) => {
      amount += parseFloat(ele.bookingAmount);
      pureWeight += parseFloat(ele.pureWeight);
    });
    rate = parseFloat(amount / pureWeight);
    dispatch(
      setBookingAverage({
        averageRate: isNaN(rate) ? "0" : rate,
        averageAmount: isNaN(amount) ? "0" : amount,
        averagePureWeight: isNaN(pureWeight) ? "0" : pureWeight,
      })
    );
  };

  return (
    <div>
      {" "}
      {bookings.bookings ? (
        <form
        // onSubmit={handleSubmit}
        >
          <div className="form-row">
            <div>
              <button
                className="btn btn-outline-primary"
                type="button"
                style={{ float: "right" }}
                onClick={() => handleAddFields()}
              >
                + Add
              </button>
            </div>
            {bookings.bookings.map((inputField, index) => (
              <Fragment key={`${inputField}~${index}`}>
                <div className="form-group col-sm-10 tableDesign">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <NumberFormat
                            value={inputField.bookingRate}
                            className="form-control"
                            thousandSeparator={true}
                            thousandsGroupStyle="lakh"
                            decimalSeparator="."
                            decimalScale={2}
                            prefix={"₹ "}
                            id="rate"
                            placeholder="Rate"
                            name="rate"
                            allowNegative={false}
                            onValueChange={(event) =>
                              handleInputChange(index, "rate", event)
                            }
                          />
                        </td>
                        <td>
                          <NumberFormat
                            value={inputField.bookingAmount}
                            className="form-control"
                            thousandSeparator={true}
                            thousandsGroupStyle="lakh"
                            decimalSeparator="."
                            decimalScale={2}
                            prefix={"₹ "}
                            id="amount"
                            placeholder="Amount"
                            name="amount"
                            allowNegative={false}
                            onValueChange={(event) =>
                              handleInputChange(index, "amount", event)
                            }
                          />
                        </td>
                        <td>
                          <NumberFormat
                            value={inputField.pureWeight}
                            className="form-control"
                            thousandSeparator={true}
                            thousandsGroupStyle="lakh"
                            decimalSeparator="."
                            decimalScale={3}
                            suffix={" grams"}
                            id="pureWeight"
                            placeholder="Pure Weight"
                            name="pureWeight"
                            allowNegative={false}
                            onValueChange={(event) =>
                              handleInputChange(index, "pureWeight", event)
                            }
                          />
                        </td>
                        <td>
                          <button
                            className="btn btn-outline-danger"
                            type="button"
                            hidden={index === 0}
                            onClick={() =>
                              handleRemoveFields(inputField.bookingId)
                            }
                          >
                            -
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="form-group col-sm-2"></div>
              </Fragment>
            ))}
          </div>
          {bookings.bookings.length >= 2 && (
            <div className="tableDesign">
              <table className="table table-bordered border-primary">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Average Rate</th>
                    <th scope="col" colSpan={2}>
                      Total Amount
                    </th>
                    <th scope="col">Total Pure Weight</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row"></th>
                    <td>
                      {numberFormat(bookings.avgBookingDetails.averageRate, 2)}
                    </td>
                    <td colSpan={2}>
                      {numberFormat(
                        bookings.avgBookingDetails.averageAmount,
                        2
                      )}
                    </td>
                    <td>
                      {numberFormat(
                        bookings.avgBookingDetails.averagePureWeight,
                        3
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </form>
      ) : (
        <></>
      )}
    </div>
  );
}
